import axiosClient from "../axios-config";

export default {
  postTicket(ticketData) {
    return axiosClient.post('/ticket', { ticket: ticketData });
  }
}
